/* unplugin-vue-components disabled */import { render } from "./DeviceOaid.vue?vue&type=template&id=781eb70c&scoped=true"
import script from "./DeviceOaid.vue?vue&type=script&lang=js"
export * from "./DeviceOaid.vue?vue&type=script&lang=js"

import "./DeviceOaid.vue?vue&type=style&index=0&id=781eb70c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781eb70c"]])

export default __exports__